// extracted by mini-css-extract-plugin
export default {"userChangeEmailCard":"UserChangeEmailCard_userChangeEmailCard__iYLYV"};